import Icon from '@/components/atoms/Icon'
import Modal from '@/components/atoms/Modal'
import { API_BASE_URL } from '@/constants/api'
import { useAppSelector } from '@/store/hooks'
import { Dialog } from '@headlessui/react'

interface EthicsPolicyProps {
	disabledOnClose?: boolean
}

export function Calendar({ disabledOnClose }: EthicsPolicyProps) {
	const { user, company } = useAppSelector((state) => state.auth)

	return (
		<Modal
			name='onboardingGoogleCalendarModal'
			disabledOnClose={disabledOnClose}
			className='md:px-12 md:py-12 max-w-[650px] dark:bg-[#E4DFF8] rounded-2xl'
		>
			<div className='flex flex-col gap-8'>
				<div className='flex flex-col gap-8 items-center'>
					<span className='flex items-center gap-2 text-xs sm:text-sm leading-[150%] font-semibold rounded-full p-2 text-[#5B3BD2] bg-[#5b3ad117]'>
						{(() => {
							if (company?.avatar) {
								return (
									<img
										src={company?.avatar}
										alt={user?.company}
										className='w-[28px] h-[28px] rounded-full'
									/>
								)
							}

							return (
								<div className='relative flex justify-center items-center w-7 h-7 overflow-clip bg-gray-100 rounded-full dark:bg-brand-primary'>
									<Icon name='default-avatar' width='18' height='18' />
								</div>
							)
						})()}
						{company?.nome
							? `Acesso exclusivo para ${company.nome}`
							: 'Acesso exclusivo'}
					</span>
					<div className='flex flex-col items-center gap-3'>
						<Dialog.Title
							as='h3'
							className='text-3xl md:text-4xl font-bold leading-[120%] text-[#1F1F1F]'
						>
							Boas-vindas à plataforma Fluency Corporate! 🎉
						</Dialog.Title>

						<p className='w-full text-lg lg:text-xl font-normal text-[#1F1F1F] leading-[150%] max-w-[508px]'>
							Para começar, conecte seu calendário para receber os convites das
							aulas ao vivo:
						</p>
					</div>
				</div>
				<div
					className='flex w-full h-auto stroke-none justify-between rounded-md py-4 px-4 lg:py-6 lg:px-6 cursor-pointer'
					style={{
						backgroundImage:
							'radial-gradient(158.1% 116.71% at 85.14% 20.18%, #5938CD 0%, #6B47ED 100%)',
					}}
					onClick={() =>
						window.open(`${API_BASE_URL}/v1/auth/google-calendar`, '_self')
					}
				>
					<div className='flex items-center w-full gap-3'>
						<span className='flex items-center justify-center w-[52px] h-[52px] lg:w-[72px] lg:h-[72px] bg-brand-primary/80 rounded-full shadow-md'>
							<Icon
								name='google-calendar'
								width='32'
								height='32'
								className='w-[22px] h-[22px] lg:w-[32px] lg:h-[32px]'
							/>
						</span>
						<p className='ml-1 lg:ml-2 text-base xs:text-lg lg:text-xl font-semibold leading-[120%] text-start text-white'>
							Conectar
							<br />
							Google Calendar
						</p>
					</div>
					<div className='flex items-center justify-end'>
						<Icon name='arrow-right' width='28' height='28' />
					</div>
				</div>
			</div>
		</Modal>
	)
}
